import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

import lazyload from './features/lazy-load';
import stickyScroll from "./features/sticky-scroll";

import VueScrollTo from "vue-scrollto";

lazyload();
stickyScroll();

initMain([], {
    AgencyPager: () => import('./vue/components/agency-pager/AgencyPager.vue'),
    AgencyAc: () => import('./vue/components/agency-ac/AgencyAc.vue'),
    Trends: () => import('./vue/components/trends/Trends.vue')
}, [VueScrollTo]);
header();